import { useEffect, useMemo } from "react";
import { sortObjByKey } from "../../../../../../../../utility/misc/sortObjByKey";
import { districtSelectUI } from "./District";
import { addressData, removeArrayDuplicates } from "./addressUtils";
import useUIBp from "../../../../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../../../../store/slices/UI";
import Select from "../../../../../../../UI/GeneralPurpose/Select";

const UIText = {
  "es-CL": { label: "Ciudad" },
  "en-US": { label: "City" },
};

export const citySelectUI = "citySelect";

const City = () => {
  const { dispatch, UI } = useUIBp();
  const district = UI[districtSelectUI] ?? "";

  const cities = useMemo(() => {
    const rawCities = addressData
      .filter((x) => x.comuna === district)
      .map((x) => ({
        label: x.ciudad,
        value: x.ciudad,
      }));

    const deduplicatedCities = removeArrayDuplicates(rawCities);

    const sortedCities = deduplicatedCities.sort((a, b) =>
      sortObjByKey(a, b, "label")
    );

    const cities = sortedCities.map((x) => ({ universal: x, value: x.value }));

    return cities;
  }, [district]);

  useEffect(() => {
    if (cities.length === 1) {
      dispatch(
        UIactions.setValue({
          id: citySelectUI,
          value: cities[0].value,
        })
      );
    }
  }, [dispatch, cities]);

  return (
    <Select
      {...{
        id: citySelectUI,
        options: cities,
        UIText,
        disabled: cities.length <= 1,
        size: {
          xl: 4,
          lg: 4,
          md: 4,
          sm: 12,
          xs: 12,
        },
      }}
    />
  );
};

export default City;
